<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <basin-input-with-selector
    [updateOnBlurOnly]="props.updateOnBlurOnly"
    [inputLeftAddonText]="props.inputLeftAddonText"
    [inputRightAddonText]="props.inputRightAddonText"
    [inputStyleClass]="props.inputStyleClass"
    [inputType]="props.type ? props.type : 'number'"
    [inputId]="props.inputId"
    [inputName]="props.inputName"
    [inputPlaceholder]="props.inputPlaceholder"
    [inputMinlength]="props.inputMinlength"
    [inputMaxlength]="props.inputMaxlength"
    [inputReadonly]="props.inputReadonly"
    [inputRequired]="props.required"
    [inputDisabled]="props.inputDisabled"
    [selectorOptions]="props.selectorOptions"
    [selectorOptionLabel]="props.selectorOptionLabel"
    [selectorOptionValue]="props.selectorOptionValue"
    [selectorOptionDisabled]="props.selectorOptionDisabled"
    [selectorUnselectable]="props.selectorUnselectable"
    [selectorTabindex]="props.selectorTabindex"
    [selectorMultiple]="props.selectorMultiple"
    [selectorAllowEmpty]="props.selectorAllowEmpty"
    [selectorStyle]="props.selectorStyle"
    [selectorStyleClass]="props.selectorStyleClass"
    [selectorAriaLabelledBy]="props.selectorAriaLabelledBy"
    [selectorDisabled]="props.selectorDisabled"
    [selectorDataKey]="props.selectorDataKey"
    [selectorAutofocus]="props.selectorAutofocus"
    [formControl]="formControl"
    [formlyAttributes]="field"
  ></basin-input-with-selector>
</span>
